<template>
  <BaseForm
    :title="formTitle"
    :formData="producerFeedmillRateData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    producerFeedmillRateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      producerFeedmillRateData: {
        producer_id: '',
        name: '',
        rate: '',
        mile_rate: ''
      },
      fields: [
        { model: 'producer_id', label: 'Producer', required: true, type: 'select', optionsUrl: '/api/v1/producer/producers/', labelField: 'name' },
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'rate', label: 'Rate ($/ton)', required: true, type: 'number' },
        { model: 'mile_rate', label: 'Mile Rate ($/mile)', required: true, type: 'number' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.producerFeedmillRateId ? `Edit Producer Feedmill Rate` : 'Add Producer Feedmill Rate';
    },
    submitUrl() {
      return this.producerFeedmillRateId ? `/api/v1/producer_feedmill_rate/producer-feedmill-rates/${this.producerFeedmillRateId}/` : '/api/v1/producer_feedmill_rate/producer-feedmill-rates/';
    },
    method() {
      return this.producerFeedmillRateId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.producerFeedmillRateId) {
      this.loadProducerFeedmillRateData();
    }
  },
  methods: {
    loadProducerFeedmillRateData() {
      axios.get(`/api/v1/producer_feedmill_rate/producer-feedmill-rates/${this.producerFeedmillRateId}/`).then(response => {
        this.producerFeedmillRateData = { ...response.data, producer_id: response.data.producer_id.id };
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Producer Feedmill Rate saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the producer feedmill rate!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
